export var makeCollapse = function makeCollapse(props) {
  var collapsed = props.collapsed;
  return "height: 100%;\n          max-height: 100%;\n          overflow: ".concat(collapsed ? 'hidden' : 'visible', ";;\n          transition: all 0.3s ease-out;");
};
export var makeCollapseToggle = function makeCollapseToggle() {
  return "";
};
export var makeCollapseContent = function makeCollapseContent(props) {
  var collapsed = props.collapsed,
      offset = props.offset;
  return "display: block;\n          position: relative;\n          min-height: ".concat(offset, "px;\n          max-height: ").concat(collapsed ? "".concat(offset, "px") : '100%', ";\n          transition: max-height .5s ease-in-out;");
};
export var makeToggleIcon = function makeToggleIcon(props) {
  var collapsed = props.collapsed;
  return "display: inline-block;\n          vertical-align: -4px;\n          transition: all .5s ease-in-out;\n          transform: ".concat(collapsed ? 'rotate(0deg)' : 'rotate(180deg)', ";");
};